import React, { Component } from 'react';

import Box from 'common/Box';
import Select from 'forms/Select/react';
import BottomButton from 'forms/BottomButton';
import styles from './DeviceSelector.module.css';
import add_blue_circle from './add_blue_circle.svg';
import InputField from '../../forms/InputField';

class DeviceSelector extends Component {
  componentDidUpdate(oldProps, oldState) {
    if (this.props.devices !== oldProps.devices) {
      this.setDeviceOptions();
    }
    if (
      this.state.brand !== oldState.brand ||
      this.state.storage !== oldState.storage
    ) {
      this.fetchDevices();
    }
  }

  setDeviceOptions = () => {
    this.setState({
      devices: this.props.devices.map(dev => ({
        value: dev.sku,
        label: `${dev.brand} ${dev.name} - ${dev.color}/${dev.capacity}`,
      }))
    });
  }

  state = {
    brand: null,
    storage: null,
    device: null,
    device_id: '',
    deviceIdError: '',
  }

  brandChange = (brand) => {
    this.setState({ brand, storage: null, device: null, devices: [] });
  }

  storageChange = (storage) => {
    this.setState({ storage, device: null, devices: [] });
  }

  devicesChange = (device) => {
    this.setState({ device });
  }

  handleChangeDeviceId = (e) => {
    this.setState({ device_id: e.target.value, deviceIdError: '' });
  }

  fetchDevices = () => {
    const { brand, storage } = this.state;
    if (!(brand && storage)) { return; }
    this.props.fetchFilteredDevices(brand.value, storage.value);
  }

  next = () => {
    if (!this.state.device_id || !/^\d{15}$/.test(this.state.device_id.trim())) {
      this.setState({ deviceIdError: 'Device ID / IMEI should be 15 digits long' });
      return;
    }
    this.setState({ deviceIdError: '' });
    this.props.nextRoute(this.props.subId, this.state.device.value, this.state.device_id);
  }

  render() {
    const { brand, storage, device, device_id, devices, deviceIdError } = this.state;
    return (
      <div className={styles.DeviceSelector}>
        <Box className={styles.BoxHeader}>
          <img src={add_blue_circle} alt="" />
          Select the device you want to protect
        </Box>
        <Box className={styles.Box}>
          <Select className={styles.Select} value={brand} label="Brand" onChange={this.brandChange} options={brandsOptions} />
          <Select className={styles.Select} value={storage} label="Storage" onChange={this.storageChange} options={storageOptions} />
          <Select className={styles.Select} value={device} label="Available Devices" onChange={this.devicesChange} options={devices} />
          <div className={styles.Select}>
            <InputField
              input={{
                value: device_id,
                onChange: this.handleChangeDeviceId,
              }}
              meta={{
                touched: Boolean(deviceIdError),
                error: deviceIdError,
              }}
              label="Device ID / IMEI"
            />
          </div>
          <BottomButton onClick={this.next} disabled={!device || !device_id}>
            Confirm your device protection
          </BottomButton>
        </Box>
      </div>
    )
  }
}

export default DeviceSelector;

const brandsOptions = [
  { value: 'Apple', label: 'Apple' },
  { value: 'Samsung', label: 'Samsung' },
  { value: 'Google', label: 'Google' },
  { value: 'Motorola', label: 'Motorola' },
  { value: 'HTC', label: 'HTC' },
]
const storageOptions = [
  { value: '8GB', label: '8GB' },
  { value: '16GB', label: '16GB' },
  { value: '32GB', label: '32GB' },
  { value: '64GB', label: '64GB' },
  { value: '128GB', label: '128GB' },
  { value: '256GB', label: '256GB' },
  { value: '512GB', label: '512GB' },
]


